var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.383 11.214H20.51A1.493 1.493 0 0019 12.611v4.028a.468.468 0 10.936 0v-3.282h.383v8.963a.68.68 0 00.68.68.68.68 0 00.68-.68v-5.749h.536v5.749a.68.68 0 00.68.68.68.68 0 00.68-.68v-8.963h.382v3.282a.468.468 0 00.936 0v-4.028a1.493 1.493 0 00-1.51-1.397zM21.946 8a1.34 1.34 0 11-1.339 1.34A1.34 1.34 0 0121.947 8zM16 8h1v15h-1zm-5.672 0a1.34 1.34 0 11-1.34 1.34A1.34 1.34 0 0110.329 8zm3.652 7.97l-1.093-3.682a1.54 1.54 0 00-1.463-1.074H9.227a1.54 1.54 0 00-1.463 1.074L6.671 15.97a.468.468 0 00.897.268l.852-2.88h.432L7.12 19.25h1.581v3.07a.68.68 0 00.68.68.68.68 0 00.68-.68v-3.07h.529v3.07a.68.68 0 001.36.005V19.25h1.59l-1.732-5.893h.423l.852 2.88a.468.468 0 00.897-.267z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--woman-man-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'WomanManCircleIcon';
export default Icon;